import isBoolean from 'foundation/js/inputValidators/isBoolean'
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'

export default [
    {
        name: 'tshirtSize',
        value: 0,
        isValid: false,
        validator: nonEmptyStringValidator
    },
    {
        name: 'participateInFreeLunch',
        value: false,
        isValid: false,
        validator: isBoolean
    }
]
